// Jours de fermeture : jours fériés et fermetures exceptionnelles.
// Module sans dépendance, utilisé au build (horaires affichés) et dans le
// navigateur (indicateur « ouvert / fermé », jours proposés dans les formulaires).
//
// Les newsletters 2022-2024 de la concession annoncent la fermeture les jours
// fériés et une fermeture annuelle en fin d'année : à confirmer chaque année.

// Fermetures exceptionnelles, dates incluses (AAAA-MM-JJ). Exemple :
// { from: "2026-12-24", to: "2027-01-04", label: "Fermeture annuelle", reopen: "mardi 5 janvier" }
export const CLOSURES = [];

// La concession ferme les jours fériés (magasin et atelier).
export const CLOSED_ON_HOLIDAYS = true;

const iso = (y, m, d) => `${y}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;

// Dimanche de Pâques (algorithme de Meeus/Jones/Butcher).
function easter(y) {
  const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
  const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
  const month = Math.floor((h + l - 7 * m + 114) / 31), day = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(Date.UTC(y, month - 1, day));
}

const cache = new Map();
// Jours fériés en France métropolitaine : { "2026-05-01": "Fête du Travail", … }
export function holidays(y) {
  if (cache.has(y)) return cache.get(y);
  const e = easter(y);
  const plus = (n) => {
    const d = new Date(e.getTime() + n * 864e5);
    return iso(d.getUTCFullYear(), d.getUTCMonth() + 1, d.getUTCDate());
  };
  const list = {
    [iso(y, 1, 1)]: "Jour de l'an",
    [plus(1)]: "Lundi de Pâques",
    [iso(y, 5, 1)]: "Fête du Travail",
    [iso(y, 5, 8)]: "Victoire 1945",
    [plus(39)]: "Ascension",
    [plus(50)]: "Lundi de Pentecôte",
    [iso(y, 7, 14)]: "Fête nationale",
    [iso(y, 8, 15)]: "Assomption",
    [iso(y, 11, 1)]: "Toussaint",
    [iso(y, 11, 11)]: "Armistice 1918",
    [iso(y, 12, 25)]: "Noël",
  };
  cache.set(y, list);
  return list;
}

// Raison de la fermeture ce jour-là (AAAA-MM-JJ), ou null si la concession suit ses horaires.
export function closedReason(day) {
  const period = CLOSURES.find((c) => day >= c.from && day <= c.to);
  if (period) return period.label;
  if (CLOSED_ON_HOLIDAYS) return holidays(Number(day.slice(0, 4)))[day] ?? null;
  return null;
}
